import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

const PieChartConversions = ({ data, colors }) => {
  const DEFAULT_COLOR = "#dddddd";

  // Filter Pie chart data
  const pieData = data.filter(
    (d) => d.name === "Lead Assigned" || d.name === "Conversions"
  );

  const hasData = pieData.some((d) => d.value > 0);

  const conversionItem = data.find((d) => d.name === "Conversion");
  const conversionPercentage = conversionItem?.value ?? 0;

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <p>{item.name}</p>
          <p>
            <strong>Value:</strong> {item.value}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <PieChart width={238} height={234}>
        <Pie
          dataKey="value"
          data={hasData ? pieData : [{ name: "No Data", value: 1 }]}
          cx={120}
          cy={110}
          outerRadius={110}
          innerRadius={80}
          startAngle={90}
          endAngle={-270}
        >
          {(hasData ? pieData : [{ name: "No Data", value: 1 }]).map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={colors[entry.name] || DEFAULT_COLOR}
            />
          ))}
        </Pie>

        {/* Center text */}
        {hasData && (
          <>
            <text
              x={120}
              y={105}
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize="20"
              fontWeight="bold"
              fill="#333"
            >
              {conversionPercentage}%
            </text>
            <text
              x={120}
              y={125}
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize="12"
              fill="#888"
            >
              Conversion
            </text>
          </>
        )}

        <Tooltip content={<CustomTooltip />} />
      </PieChart>

      {/* Custom Legend */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "10px 20px",
          borderRadius: "15px",
          marginTop: "1px",
          marginLeft: "16px",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          fontSize: "13px",
        }}
      >
        {pieData.map((item, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: colors[item.name] || DEFAULT_COLOR,
                borderRadius: "50%",
                marginRight: "10px",
              }}
            ></div>
            <div style={{ width: "120px", color: "#666" }}>{item.name} :</div>
            <div style={{ fontWeight: "bold", color: "#333" }}>{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChartConversions;
